import React from 'react'
import PropTypes from 'prop-types'

import iconSuccess from '../assets/images/smile-success.png'
import iconFaild from '../assets/images/smile-faild.png'

const ResultContainer = ({rating, idFaq, handleResultAsked}) => {
  return (
    <div className={`result-container ${findResult(rating)}`}>
      <div className="title-container">
      <span >Ми відповіли на Ваше питання?</span>
      </div>
      <div className="button-container">
        <button className='button-result success' onClick={rating ? undefined : handleResultAsked(idFaq, 1, idFaq)}>
          <div className='result_container'>
            <img src={iconSuccess} alt='success' />
            <span>Так</span>
          </div>
        </button>
        <button className='button-result faild' onClick={rating ? undefined : handleResultAsked(idFaq, 0, idFaq)}>
          <div className='result_container'>
            <img src={iconFaild} alt='faild' />
            <span>Ні</span>
          </div>
        </button>
      </div>
    </div>
  )
}
const findResult = rating => {
  console.log(rating);
  if(!rating && rating !== 0 ) return ''
  return rating === 0 ? 'faild' : 'success'
}

ResultContainer.propTypes = {
  handleResultAsked: PropTypes.func.isRequired,
  idFaq: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  rating: PropTypes.number,
}

export default ResultContainer